import "./footer.css"
import { Link } from "react-router-dom";

export default function Footer(){
    return(
        <footer className="wrapper footer">
            <main >
                <section className="footerLogo">
                    <figure>
                        <img src="../images/Logo-02 1.png" alt="Sai Loans"/>
                    </figure>
                </section>
                <section className="footerContact">
                    <article>
                        <h2>Address</h2>
                        <p>No.43/A, East Gandhi Nagar,Auxilium Road, Katpadi,Vellore - 632006.</p>
                    </article>
                    <article>
                        <h2>Contact Us</h2>
                        <p><img src="../images/call.svg" alt="c"/>+91 7708 323 563</p>
                        <p><img src="../images/mail.svg" alt="c"/>balajisinghbala05@gmail.com</p>
                    </article>
                </section>
                <section className="footerMenu">
                    <ul>
                        <li><Link to={"/"}>Home</Link></li>
                        <li><Link to={"/about"}>About Us</Link></li>
                        <li><Link to={"/service"}>service</Link></li>
                        <li><Link to={"/contact"}>Contact Us</Link></li>
                        <li><Link to={"/terms"}>Terms & Conditions</Link></li>
                        <li><Link to={"/policy"}>Privacy Policy</Link></li>
                    </ul>
                </section>
            </main>
            <a href="https://trulle.in/" className="footerRights">@Trulle</a>
        </footer>
    )
}